import React from "react";

function NumberCommas({ number }) {
  if (typeof number !== "number" || isNaN(number)) {
    return <span style={{ textAlign: "right", display: "block" }}>-</span>;
  }

  const formattedNumber = Number(number.toFixed(2)).toLocaleString();

  return (
    <span style={{}}>
      {formattedNumber}
    </span>
  );
}

export default NumberCommas;